import { defineStore } from "pinia";
//参数1：定义一个仓库的唯一id名，Pinia会将所有的容器挂载到根容器；参数2：选项对象
export const useMainStore = defineStore('main', {
  state: () => {//state必须是函数，是避免在服务端渲染时的交叉请求导致的状态数据污染；必须是箭头函数，为了更好的TS类型推导
    return {
      tabIndex: "0",//底部导航栏当前选中索引
      userInfo: null,//用户登录信息
      globalLoading: false,//全局加载状态
      // backlogNum: 0,//待办数量
      noticeNum: 0,//消息通知数量
      isOrderDot: 0,//首页待处理的订单数量
      unloadingOrderNum: 0,//已卸货订单数量
      webSocketRes: null,
    }
  },
  getters: {
    getTabIndex(state) { return state.tabIndex },
    getUserInfo(state) { return state.userInfo },
    getBtnLoading(state) { return state.btnLoading },
  },
  actions: {
    setWebSocketRes(webSocketRes) {
      this.webSocketRes = webSocketRes
    },
    setGlobalLoading(isLoading) {
      this.globalLoading = isLoading
    },
    setTabIndex(index) {
      this.tabIndex = index
    },
    setUserInfo(userInfo) {
      this.userInfo = userInfo
    },
    // setBacklogNum(backlogNum) {
    //   this.backlogNum = backlogNum
    // },
    setNoticeNum(noticeNum) {
      this.noticeNum = noticeNum
    },
    setIsOrderDot(isOrderDot) {
      this.isOrderDot = isOrderDot
    },
    setUnloadingOrderNum(unloadingOrderNum) {
      this.unloadingOrderNum = unloadingOrderNum
    },

  },
  persist: {
    // 修改存储中使用的键名称，默认为当前 Store的 id
    //  key: 'storekey',
    //存储方式
    storage: localStorage,//localStorage
    //设置需要存储的字段
    // paths: ['count'],
  }
})